import { render, staticRenderFns } from "./notification-navbar.component.vue?vue&type=template&id=47fee626"
import script from "./notification-navbar.component.vue?vue&type=script&lang=js"
export * from "./notification-navbar.component.vue?vue&type=script&lang=js"
import style0 from "./notification-navbar.component.vue?vue&type=style&index=0&id=47fee626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports